import React, { useState } from "react"
import Svg from "./Svg"
import { useFill } from "./useFill"
import * as common from "./common"

const Serving = (props) => {
    const { x1, y1, x2, y2, lastLineSegment = true, highlight, lineColor } = props

    const markerEnd = lastLineSegment ? "url(#serving-end)" : ""

    const hoverColor = common.defaultLineHighlightColor
    const defaultColor = lineColor || common.defaultLineColor

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, setFill })

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <defs>
                <marker
                    id='serving-end'
                    markerWidth='20'
                    markerHeight='20'
                    refX='12'
                    refY='6'
                    orient='auto'
                >
                    <path d='M0 0, 12 6, 0 12' stroke='#000' fill='none' />
                </marker>
            </defs>
            <line
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke={fill}
                strokeWidth='1'
                markerEnd={markerEnd}
            />
        </Svg>
    )
}

export default Serving
